import { render, staticRenderFns } from "./company.vue?vue&type=template&id=174e7bf8"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('174e7bf8')) {
      api.createRecord('174e7bf8', component.options)
    } else {
      api.reload('174e7bf8', component.options)
    }
    module.hot.accept("./company.vue?vue&type=template&id=174e7bf8", function () {
      api.rerender('174e7bf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/select/company.vue"
export default component.exports